import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GALLERY_MODE, ModelCardRenderedSelection } from 'src/app/models/card';
import { UtilityFunctionsService } from 'src/app/shared/providers/utility-functions.service';

@Component({
  selector: 'app-web-publishbulk',
  templateUrl: './web-publishbulk.component.html',
  styleUrls: ['./web-publishbulk.component.scss']
})
export class WebPublishBulkComponent implements OnInit {

  @Input() cardsToSelect: ModelCardRenderedSelection[];
  @Input() allCardsToSelect: ModelCardRenderedSelection[];
  @Input() disableClick: boolean = false;

  @Output() cardSelected = new EventEmitter<ModelCardRenderedSelection[]>();

  GALLERY_MODE = GALLERY_MODE;

  constructor(
    public utilityService: UtilityFunctionsService
  ) { }

  ngOnInit(): void {
  }

  onCardSelected(cardClicked: ModelCardRenderedSelection): void {
    if (this.disableClick || !cardClicked || cardClicked.isDisabled) return;

    // Single-select: deselect all others before toggling clicked card
    this.getSelectableCards()
      .filter(c => c.id !== cardClicked.id)
      .forEach(c => { c.isSelected = false; this.updateAllCardsToSelectState(c); });

    cardClicked.isSelected = !cardClicked.isSelected;
    this.updateAllCardsToSelectState(cardClicked);
    this.cardSelected.emit(this.getSelectedPublishableCards());
  }

  private updateAllCardsToSelectState(cardClicked: ModelCardRenderedSelection): void {
    if (!this.allCardsToSelect) return;
    const cardInAllCards = this.allCardsToSelect.find(card => card.id === cardClicked.id);
    if (cardInAllCards) {
      cardInAllCards.isSelected = cardClicked.isSelected;
    }
  }

  private getSelectableCards(): ModelCardRenderedSelection[] {
    return (this.cardsToSelect || []).filter(card => !card.isDisabled);
  }

  private getSelectedPublishableCards(): ModelCardRenderedSelection[] {
    return this.getSelectableCards().filter(card => card.isSelected);
  }

  public getDisabledCards(): ModelCardRenderedSelection[] {
    return (this.cardsToSelect || []).filter(card => card.isDisabled);
  }

  public selectOrDeselectAllItems(): void {
    const selectableCards = this.getSelectableCards();
    if (selectableCards.length === 0) {
      this.cardSelected.emit([]);
      return;
    }

    const isAllSelectableSelected = selectableCards.every(card => card.isSelected);
    selectableCards.forEach(card => {
      card.isSelected = !isAllSelectableSelected;
      this.updateAllCardsToSelectState(card);
    });
    this.cardSelected.emit(this.getSelectedPublishableCards());
  }
}
